import { useEffect } from 'react'

import {
  countHiddenLayoutBlocks,
  isBlockOffCanvas,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

const useHiddenBlocks = ({
  hiddenBlocks,
  showHiddenBlocks,
  layout,
  selectedBlockId,
  isSelectedBlockOpen,
  clearSelection,
}) => {
  const isSelectedBlockOffCanvas = isBlockOffCanvas({ blockId: selectedBlockId, hiddenBlocks, showHiddenBlocks })
  const hiddenBlockCount = countHiddenLayoutBlocks(layout, hiddenBlocks)

  useEffect(() => {
    if (isSelectedBlockOffCanvas && !isSelectedBlockOpen) clearSelection()
  }, [isSelectedBlockOffCanvas, isSelectedBlockOpen, clearSelection])

  return {
    isSelectedBlockHidden: Boolean(hiddenBlocks[selectedBlockId]),
    hiddenBlockCount,
    showHiddenBlocksBanner: !showHiddenBlocks && hiddenBlockCount > 0,
  }
}

export default useHiddenBlocks
